import React from "react";

import { changeSecondsToString } from "../../../hooks/useCountdown";
import EndConfirmationModule from "../EndMatchEvent/EndMatch";
import { formatMatches } from "../../../utils/format-matches";

import styles from "./bottom-timer-display.module.scss";
import fonts from "../../../../css/components/fonts.scss";

const isDraw = (homeGoals, awayGoals) => {
    return homeGoals === awayGoals;
};

const BottomTimers = ({
    quarterParams,
    totalTimePlayed,
    setTimersPerQuarter,
    isLiveTickerStaff,
    quarterSelected,
    matchData,
    matchStatus,
    setComponentToInsertInModal,
    setEndConfirmationModalOpen,
}) => {
    const { quarterStarted, quarterStopped, quarterEnded, timePlayed, id } =
        quarterParams || {};
    const { quarter4, matchHasShootout, matchPosts } = matchData;
    const isShootout =
        quarter4 &&
        matchHasShootout &&
        matchPosts?.some(
            (post) => post.additionalData === "Start of a shootout"
        );
    const penaltyShootActive =
        matchPosts?.length && matchPosts[matchPosts.length - 1].postType === 32;
    const [period] = formatMatches(matchData.formatObject);
    const quarterNumber = +quarterSelected.slice(-1);
    const lastPeriod = period === quarterNumber;
    const draw = isDraw(matchData.homeGoals, matchData.awayGoals);
    const handleEndButtonClick = () => {
        setComponentToInsertInModal(EndConfirmationModule);
        setEndConfirmationModalOpen(true);
        setTimersPerQuarter((details) => ({
            ...details,
            [id]: {
                ...details[id],
                ...(quarterEnded ? { timePlayed: 0, timeLeft: 900 } : {}),
                quarterStopped: true,
                quarterStarted: false,
            },
        }));
    };

    return (
        <div className={styles["bottom-timers"]}>
            {!isShootout && (
                <div className={styles["bottom-timers__sec"]}>
                    <button>40 Sek</button>
                </div>
            )}
            {!isShootout && (
                <div
                    className={`${styles["bottom-timers__time"]} ${fonts.fs20}`}
                >
                    <span>
                        {changeSecondsToString("timePlayed", timePlayed)}
                    </span>
                    <span>
                        {changeSecondsToString(
                            "totalTimePlayed",
                            totalTimePlayed
                        )}
                    </span>
                </div>
            )}
            {!isLiveTickerStaff && (
                <div
                    className={styles["bottom-timers__end"]}
                    style={{
                        ...(isShootout ? { marginLeft: "auto" } : {}),
                        ...(matchStatus > 3 || penaltyShootActive
                            ? { opacity: "0.3", pointerEvents: "none" }
                            : {}),
                    }}
                >
                    {!quarterStarted && (
                        <>
                            <button
                                className={`${styles["bottom-timers__end-button"]} ${fonts.fs10}`}
                                style={{
                                    ...(lastPeriod || isShootout
                                        ? { display: "none" }
                                        : {}),
                                }}
                                onClick={handleEndButtonClick}
                            >
                                {quarterStopped
                                    ? "END PERIOD"
                                    : "RESTART PERIOD"}
                            </button>
                            {(lastPeriod || isShootout) && (
                                <button
                                    className={
                                        styles["bottom-timers__end-button"]
                                    }
                                    style={{
                                        backgroundColor: "red",
                                        color: "white",
                                        display: "none",
                                        ...(lastPeriod || isShootout
                                            ? {
                                                  gridColumn: "span 2",
                                                  display: "block",
                                              }
                                            : {}),
                                        ...(draw && isShootout
                                            ? {
                                                  opacity: "0.3",
                                                  pointerEvents: "none",
                                              }
                                            : {}),
                                    }}
                                    onClick={() => {
                                        setComponentToInsertInModal(
                                            EndConfirmationModule
                                        );
                                        setEndConfirmationModalOpen(true);
                                    }}
                                >
                                    END MATCH
                                </button>
                            )}
                        </>
                    )}
                </div>
            )}
            {isLiveTickerStaff && (
                <div
                    className={`${styles["bottom-timers__staff"]} ${fonts.fs10}`}
                >
                    <button>Umpire 1</button>
                    <button>Umpire 2</button>
                </div>
            )}
        </div>
    );
};

export default BottomTimers;
